import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {
  useAccountSwitch,
  useIsAuthenticated,
} from '@zapier/promotions/src/hooks';

import { isBrowser } from '@zapier/promotions/src/utils';

import { endOfYearSale as EndOfYearSaleQuery } from './types/endOfYearSale';

export const endOfYearSaleQuery = gql`
  query endOfYearSale($accountId: Int!) {
    account(id: $accountId) {
      id
      plan {
        amount
        id
      }
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useEndOfYearSale = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();
  const accountId = isBrowser()
    ? localStorage.getItem('currentAccountId')
    : undefined;

  const { data, loading: isLoadingAccount, error } = useQuery<
    EndOfYearSaleQuery
  >(endOfYearSaleQuery, {
    skip: skip || !isAuthenticated || !accountId,
    variables: {
      accountId: parseInt(accountId ?? ''),
    },
  });

  const {
    isLoading: isLoadingEndOfYearSaleActiveSwitch,
    isSwitchOn: isEndOfYearSaleActiveSwitchOn,
  } = useAccountSwitch('endOfYearSaleActive');

  const {
    isLoading: isLoadingEndOfYearSaleAdSwitch,
    isSwitchOn: isEndOfYearSaleAdSwitchOn,
  } = useAccountSwitch('endOfYearSaleAd');

  const currentPlan = data?.account?.plan;
  const shouldRenderAdBanner =
    isEndOfYearSaleAdSwitchOn && currentPlan?.amount === 0;

  return {
    currentPlanMonthlyAmount: (currentPlan?.amount ?? 0) / 12,
    error,
    isLoading:
      isLoadingAccount ||
      isLoadingEndOfYearSaleActiveSwitch ||
      isLoadingEndOfYearSaleAdSwitch,
    shouldRenderAdBanner,
    shouldRenderSaleActiveBanner: isEndOfYearSaleActiveSwitchOn,
    shouldRenderTopBarBanner: shouldRenderAdBanner,
  };
};
